export default "__VITE_ASSET__Du6RRO3n__"